import {
  ClientErrorSource,
  tracker,
  trackingEvents,
} from "src/instrumentation/customTrackingEvents";
import { parseUrl } from "src/router/urls";
import { logger } from "src/utils/logger";

type ReactErrorInfo = { componentStack?: string | null };

const normalizeError = (error: unknown): Error =>
  error instanceof Error ? error : new Error(String(error));

export const instrumentError = (
  error: unknown,
  errorInfo?: ReactErrorInfo,
  errorSource: ClientErrorSource = "manual",
) => {
  const normalizedError = normalizeError(error);
  const { orgId } = parseUrl(window.location.href);
  tracker.emit(
    trackingEvents.clientRuntimeError({
      error_message: normalizedError.message ?? "",
      error_stack: normalizedError.stack ?? "",
      error_component_stack: errorInfo?.componentStack ?? "",
      error_source: errorSource,
      organization_id: orgId,
    }),
  );
};

// Handlers for the createRoot error options. Supplying these options replaces
// React's defaults (console + window.reportError), so each handler restores
// console and AWS RUM reporting via logger.error before emitting the event.
export const createRootErrorHandler =
  (errorSource: Exclude<ClientErrorSource, "manual">) =>
  (error: unknown, errorInfo?: ReactErrorInfo): void => {
    const normalizedError = normalizeError(error);
    logger.error(`React ${errorSource} error`, normalizedError, errorInfo);
    instrumentError(normalizedError, errorInfo, errorSource);
  };
